"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var cart_1 = require("../../utils/cart");
var CartContext_1 = require("./CartContext");
var ga_1 = require("../../utils/ga");
var UpsellModalV2_1 = require("../common/UpsellModalV2");
var Parser_1 = require("../Parser");
var YotpoStar_1 = require("../Yotpo/YotpoStar");
var AddToCart_1 = require("../common/AddToCart");
var UpsellItem = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var prod = _a.prod;
    if (!prod) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var upsellModalData = ((_b = prod.upsellModalData) === null || _b === void 0 ? void 0 : _b.reference.field.value) &&
        JSON.parse((_c = prod.upsellModalData) === null || _c === void 0 ? void 0 : _c.reference.field.value);
    var _s = (0, hooks_1.useContext)(CartContext_1.default), cart = _s.cart, cartOpen = _s.open, renderCart = _s.renderCart;
    var _t = (0, hooks_1.useState)(false), open = _t[0], setOpen = _t[1];
    (0, hooks_1.useEffect)(function () {
        if (!cartOpen && open) {
            setOpen(false);
        }
    }, [cartOpen]);
    var replacedItem = cart.items.find(function (item) { var _a; return item.handle === ((_a = prod.replace) === null || _a === void 0 ? void 0 : _a.value); });
    var sub = (0, cart_1.isSubscriptionItem)(prod);
    var openModal = function () {
        setOpen(true);
    };
    var handleCtaClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, (0, cart_1.updateCart)(event, replacedItem)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, renderCart()];
                case 3:
                    _a.sent();
                    (0, ga_1.sendEventAddToCart)(prod, prod.variants.nodes[0], ga_1.GaMethodValue.cartUpsell);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('Error adding to cart:', error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    //temporary list of product handles that learn more button should not show for
    var productsWithoutLearnMore = [
        'meno',
        'hormone-balance-kit',
        'sex-collection',
        'revitalizing-sex-collection',
    ];
    var hasLearnMore = productsWithoutLearnMore.some(function (item) { return !prod.handle.includes(item); });
    var upsellDescriptions = {
        'URO | Vaginal Probiotic Capsule': {
            description: 'For healthy odor & pH [br]1-month supply',
        },
        'FLO | Ovarian Support Vitamin Capsule': {
            name: 'FLO | Ovarian Support Capsule',
            description: 'For hormone balance & cycle regularity [br]1-month supply',
        },
        'FLO | PMS Vitamin Capsule': {
            name: 'FLO | PMS Relief Capsule',
            description: 'For period bloating & breakouts [br]1-month supply',
        },
        'MENO | Menopause Vitamin Capsule': {
            name: 'MENO | Menopause Relief Capsule',
            description: 'For hot flashes & mood swings [br]1-month supply',
        },
        'MENO | Vaginal Moisture Capsule': {
            description: 'With sexual function & arousal support [br]1-month supply',
        },
        'URO | Urinary Health Capsule': { description: 'For urinary tract comfort [br]1-month supply' },
        'URO | Bladder Control Capsule': {
            description: 'For urinary urgency & leakage [br]1-month supply',
        },
        'URO | Intimate Deodorant': {
            description: 'Odor, moisture & chafing control [br]1-month supply',
        },
        'PREGGO | Conception Support Capsule': {
            description: 'For female reproductive health [br]1-month supply',
        },
        'PREGGO | Sperm Health Capsule': {
            description: 'For male reproductive health [br]1-month supply',
        },
        'GOGO | Bloating and Gas Capsule': {
            name: 'GOGO | Bloating + Gas Relief Capsule',
            description: 'Ease digestive discomfort [br]1-month supply',
        },
        'GOGO | Fiber Gummy': {
            name: 'GOGO | Prebiotic Fiber Gummy',
            description: 'For health digestion & weight management [br]1-month supply',
        },
        'WILLO | Hair Growth Support Capsule': {
            description: 'For thicker, fuller hair [br]1-month supply',
        },
        'MOTO | Metabolism Vitamin Capsule': {
            name: 'MOTO | Metabolism Support Capsule',
            description: 'For enhanced calorie burn [br]1-month supply',
        },
        'RETRO | Acne Relief Vitamin Capsule': {
            name: 'RETRO | Acne Relief Capsule',
            description: 'For clearer, healthier skin [br]1-month supply',
        },
        'RETRO | Glowing Skin Gummy Vitamin': {
            description: 'For collagen production [br]1-month supply',
        },
        'URO - Vaginal Probiotic Capsules': {
            name: 'URO | Vaginal Probiotic Capsule',
            description: 'For healthy odor & pH [br]1 bottle delivers every month',
        },
        'FLO - Ovarian Support Vitamin Capsules': {
            name: 'FLO | Ovarian Support Capsule',
            description: 'For hormone balance & cycle regularity [br]1 bottle delivers every month',
        },
        'FLO - PMS Vitamin Capsules': {
            name: 'FLO | PMS Relief Capsule',
            description: 'For period bloating & breakouts [br]1 bottle delivers every month',
        },
        'FLO - PMS Gummy Vitamins': {
            name: 'FLO | PMS Gummy Vitamins',
            description: 'For period bloating & breakouts [br]1 bottle delivers every month',
        },
        'MENO - Menopause Vitamin Capsules': {
            name: 'MENO | Menopause Relief Capsule',
            description: 'For hot flashes & mood swings [br]1 bottle delivers every month',
        },
        'MENO - Vaginal Moisture Capsules': {
            name: 'MENO | Vaginal Moisture Capsule',
            description: 'With sexual function & arousal support [br]1 bottle delivers every month',
        },
        'URO - Urinary Health Capsules': {
            name: 'URO | Urinary Health Capsule',
            description: 'For urinary tract comfort [br]1 bottle delivers every month',
        },
        'URO - Bladder Control Capsules': {
            name: 'URO | Bladder Control Capsule',
            description: 'For urinary urgency & leakage [br]1 bottle delivers every month',
        },
        'URO - Intimate Deodorants': {
            name: 'URO | Intimate Deodorant',
            description: 'Odor, moisture & chafing control [br]1 bottle delivers every month',
        },
        'PREGGO - Conception Support Capsules': {
            name: 'PREGGO | Conception Support Capsuled',
            description: 'For female reproductive health [br]1 bottle delivers every month',
        },
        'PREGGO - Sperm Health Capsules': {
            name: 'PREGGO | Sperm Health Capsule',
            description: 'For male reproductive health [br]1 bottle delivers every month',
        },
        'GOGO - Bloating and Gas Capsules': {
            name: 'GOGO | Bloating + Gas Relief Capsule',
            description: 'Ease digestive discomfort [br]1 bottle delivers every month',
        },
        'GOGO - Fiber Gummies': {
            name: 'GOGO | Prebiotic Fiber Gummy',
            description: 'For health digestion & weight management [br]1 bottle delivers every month',
        },
        'WILLO - Hair Growth Support Capsules': {
            name: 'WILLO | Hair Growth Support Capsule',
            description: 'For thicker, fuller hair [br]1 bottle delivers every month',
        },
        'MOTO - Metabolism Vitamin Capsules': {
            name: 'MOTO | Metabolism Support Capsule',
            description: 'For enhanced calorie burn [br]1 bottle delivers every month',
        },
        'RETRO - Acne Relief Vitamin Capsules': {
            name: 'RETRO | Acne Relief Capsule',
            description: 'For clearer, healthier skin [br]1 bottle delivers every month',
        },
        'RETRO - Glowing Skin Gummy Vitamins': {
            name: 'RETRO | Glowing Skin Gummy Vitamin',
            description: 'For collagen production [br]1 bottle delivers every month',
        },
    };
    var productTitle = window.isCartUpsellTest && upsellDescriptions[prod.title].name
        ? upsellDescriptions[prod.title].name
        : prod.title;
    var upsellDescription = window.isCartUpsellTest
        ? upsellDescriptions[prod.title].description
        : (_d = prod.upsellCardText) === null || _d === void 0 ? void 0 : _d.value;
    var numReviews = (_e = prod.reviewsCount) === null || _e === void 0 ? void 0 : _e.value;
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item" },
            (0, preact_1.h)("img", { class: "cart-section__you-may-also-like-item-image", src: (_f = prod.featuredImage) === null || _f === void 0 ? void 0 : _f.src }),
            (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-info" },
                (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-info-product" },
                    ((_g = prod.upsellStatus) === null || _g === void 0 ? void 0 : _g.value) && ((0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-badge" }, prod.upsellStatus.value)),
                    (0, preact_1.h)("div", null,
                        (0, preact_1.h)("h4", { class: "cart-section__you-may-also-like-item-header" }, productTitle),
                        (0, preact_1.h)("div", { class: "upsell-star__container" },
                            numReviews && numReviews < 1000 && ((0, preact_1.h)("p", { class: "upsell-star__reviews upsell-star__reviews--left" }, (_h = prod.reviewsAverage) === null || _h === void 0 ? void 0 : _h.value)),
                            (0, preact_1.h)(YotpoStar_1.default, { score: (_k = (_j = prod.reviewsAverage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : 0, size: "small", id: "cart-upsell-yotpo-star-".concat(prod.handle), color: "#ff561c" }),
                            numReviews && numReviews >= 1000 && ((0, preact_1.h)("p", { class: "upsell-star__reviews upsell-star__reviews--right" }, (_l = prod.reviewsCount) === null || _l === void 0 ? void 0 :
                                _l.value,
                                " Reviews"))),
                        upsellDescription && ((0, preact_1.h)("p", { class: "cart-section__you-may-also-like-item-body" }, (0, Parser_1.parse)(upsellDescription))),
                        (0, preact_1.h)("div", null, hasLearnMore && upsellModalData && ((0, preact_1.h)("button", { onClick: openModal, class: "cart-section__you-may-also-like-item-button" },
                            (0, preact_1.h)("span", { class: "cart-section__you-may-also-like-item-button-text" }, "Learn More"),
                            "\u2192"))))),
                (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-price-cta" },
                    (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-price" },
                        prod.variants.nodes[0].compareAtPrice && ((0, preact_1.h)("span", { class: "cart-section__you-may-also-like-item-price--strikethrough" }, (0, hydrogen_react_1.useMoney)({
                            amount: String(Math.ceil(+prod.variants.nodes[0].compareAtPrice.amount)),
                            currencyCode: 'USD',
                        }).withoutTrailingZeros)),
                        "\u00A0",
                        (0, hydrogen_react_1.useMoney)(prod.variants.nodes[0].price).withoutTrailingZeros,
                        sub ? '/mo' : ''),
                    (0, preact_1.h)("div", null,
                        (0, preact_1.h)("form", { method: "POST", action: "/cart/add", onSubmit: function (event) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, handleCtaClick(event)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            }); }); } },
                            (0, preact_1.h)("input", { type: "hidden", name: "quantity", value: "1" }),
                            (0, preact_1.h)("input", { type: "hidden", name: "id", value: Number((_m = prod.variants.nodes[0]) === null || _m === void 0 ? void 0 : _m.id.split('/')[4]) }),
                            prod.sellingPlanGroups.nodes.length ? ((0, preact_1.h)("input", { type: "hidden", name: "selling_plan", value: Number((_r = (_q = (_p = (_o = prod.sellingPlanGroups.nodes[0]) === null || _o === void 0 ? void 0 : _o.sellingPlans) === null || _p === void 0 ? void 0 : _p.nodes[0]) === null || _q === void 0 ? void 0 : _q.id) === null || _r === void 0 ? void 0 : _r.split('/')[4]) })) : ((0, preact_1.h)(preact_1.Fragment, null)),
                            (0, preact_1.h)("button", { class: "cart-section__you-may-also-like-item-cta" }, "add")))))),
        upsellModalData && ((0, preact_1.h)(UpsellModalV2_1.default, { open: open, price: prod.variants.nodes[0].price, setOpen: setOpen, upsellModalData: upsellModalData, handleAddToCart: function () { return (0, AddToCart_1.handleAddToCart)(prod); } }))));
};
exports.default = UpsellItem;
